import { defineComponent as _defineComponent } from 'vue'
import { computed, onUnmounted, toRefs, useContext } from '@nuxtjs/composition-api';
import type { MetaUser } from '~/core/models/MetaUser';
import { GETTERS as SIDEBAR_GETTERS, ACTIONS as SIDEBAR_ACTIONS } from '~/store/affility/layout/sidebar/names';

interface Props {
    user: MetaUser,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileLanguages',
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as { user: MetaUser };



const {
    user,
} = toRefs(props);

const { store } = useContext();

const isLanguagesOpen = computed(() => store.getters[`affility/layout/sidebar/${SIDEBAR_GETTERS.MOBILE_LANGUAGES_SIDEBAR_OPEN}`]);
const closeLanguages = store.dispatch.bind(null, `affility/layout/sidebar/${SIDEBAR_ACTIONS.CLOSE_MOBILE_LANGUAGES_SIDEBAR}`);

const closeLanguagesAndOpenProfile = store.dispatch.bind(null, `affility/layout/sidebar/${SIDEBAR_ACTIONS.CLOSE_LANGUAGES_AND_OPEN_PROFILE_SIDEBAR}`);
const closeLanguagesesAndOpenGeneralSidebar = store.dispatch.bind(null, `affility/layout/sidebar/${SIDEBAR_ACTIONS.CLOSE_LANGUAGES_AND_OPEN_GENERAL_SIDEBAR}`);

const goBack = () => {
    if (user.value) {
        closeLanguagesAndOpenProfile();
    } else {
        closeLanguagesesAndOpenGeneralSidebar();
    }
};

onUnmounted(() => {
    closeLanguages();
});

return { __sfc: true,props, user, store, isLanguagesOpen, closeLanguages, closeLanguagesAndOpenProfile, closeLanguagesesAndOpenGeneralSidebar, goBack }
}

})